import { getPageIndex } from './getPageIndex';

export const getPagesBetween = (refs: Element[], startPageIndex: number, endPageIndex: number) => (
  !!refs.length && refs.filter((el) => {
    const pageIndex = getPageIndex(el);
    return pageIndex > startPageIndex && pageIndex < endPageIndex;
  })
);
